import { metisSepolia } from './metisSepoliachain';
export const projectId = 'b6479949308afdd1202f8d933ec182ec';
import { getDefaultConfig, getDefaultWallets } from '@rainbow-me/rainbowkit';
import {
    argentWallet,
    imTokenWallet,
    ledgerWallet,
    okxWallet,
    oneKeyWallet,
    trustWallet,
    uniswapWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { andromeda } from './metisChain';
import { mainnet, sepolia } from 'viem/chains';
import { goated } from './goatChain';
const { wallets: defaultWallets } = getDefaultWallets();
const wallets = [
    ...defaultWallets,
    {
        groupName: 'Other',
        wallets: [
            argentWallet,
            trustWallet,
            ledgerWallet,
            okxWallet,
            imTokenWallet,
            uniswapWallet,
            oneKeyWallet,
        ],
    },
];

const chainConfig = {
    chains: [mainnet, sepolia, andromeda, metisSepolia, goated],
    appName: 'Metis Bridge Protocol',
    projectId: projectId,
    wallets,
};

export default getDefaultConfig(chainConfig as any);
